import React from 'react'
import { classNames, variationName } from './../../utils/styles'
import PropTypes from 'prop-types'
import styles from './TextContainer.scss'

export default function TextContainer({ spacing, children, asCard = false }) {
  const className = classNames(
    styles.TextContainer,
    spacing && styles[variationName('spacing', spacing)],
    asCard && styles.AsCard,
  )

  return <div className={className}>{children}</div>
}
TextContainer.propTypes = {
  spacing: PropTypes.string,
  asCard: PropTypes.bool,
  children: PropTypes.any.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/TextContainer/index.js